import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
});

export const fetchProducts = async (params = {}) => {
  const query = {};
  if (params.lengths?.length) query.lengths = params.lengths.join(",");
  if (params.colors?.length) query.colors = params.colors.join(",");
  if (params.laceTypes?.length) query.lace_types = params.laceTypes.join(",");
  if (params.category && params.category !== "All") query.category = params.category;
  if (params.minPrice != null) query.min_price = params.minPrice;
  if (params.maxPrice != null) query.max_price = params.maxPrice;
  if (params.search) query.search = params.search;
  if (params.sort) query.sort = params.sort;
  const { data } = await api.get("/products", { params: query });
  return data;
};

export const fetchFilters = async () => {
  const { data } = await api.get("/filters");
  return data;
};

export const adminLogin = async (password) => {
  const { data } = await api.post("/admin/login", { password });
  return data;
};

export const adminUpdateProduct = async (handle, updates, password) => {
  const { data } = await api.patch(`/admin/products/${handle}`, updates, {
    headers: { "X-Admin-Password": password },
  });
  return data;
};

export const adminUploadImage = async (file, password) => {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await api.post("/admin/upload", formData, {
    headers: {
      "X-Admin-Password": password,
      "Content-Type": "multipart/form-data",
    },
    timeout: 60000,
  });
  return data.url;
};

export const adminCreateProduct = async (password) => {
  const { data } = await api.post("/admin/products", null, {
    headers: { "X-Admin-Password": password },
  });
  return data;
};

export const adminDeleteProduct = async (handle, password) => {
  const { data } = await api.delete(`/admin/products/${handle}`, {
    headers: { "X-Admin-Password": password },
  });
  return data;
};

export const adminShopifyStats = async (password) => {
  const { data } = await api.get("/admin/shopify/stats", {
    headers: { "X-Admin-Password": password },
    timeout: 20000,
  });
  return data;
};
